import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Router from "./routes/Router";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <>
      <Router />
      <CookieBanner />
    </>
  );
}

export default App;
